import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi, communityUrl } from "api";
import { useGetAll } from "./crudService";

const endpoint:string = 'audit-log';

export function useSetAuditDigestSubscription() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ subscribed, conductor }:{ subscribed:boolean, conductor?:number|null }) => {
            const { data } = await authenticatedApi.post(`/${endpoint}/subscription`, { subscribed, conductor });
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [`${endpoint}_filters`], exact: false });
        },
    });
}

export function useGetAuditLog(params:any, queryParams:any = {}) {
    return useGetAll({
        queryKey: [endpoint],
        placeholderData: keepPreviousData,
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
        retry: false,
        ...queryParams,
    }, params);
}

export function useGetAuditLogFilters(conductor:number|null = null, queryParams:any = {}) {
    return useQuery({
        queryKey: [`${endpoint}_filters`, conductor],
        queryFn: async () => {
            const suffix = conductor ? `?conductor=${conductor}` : '';
            const { data } = await authenticatedApi.get(`/${endpoint}/filters${suffix}`);
            return data;
        },
        staleTime: 5 * 60 * 1000,
        ...queryParams,
    });
}

export function auditEventKey(event:any):string {
    return `${event.subdomain}-${(event.revision_ids || []).join('_')}`;
}

const entityPaths:Record<string, string> = {
    businesses: 'businesses',
    properties: 'properties',
    contacts: 'contacts',
    workplans: 'work-plans',
    events: 'events',
    opportunities: 'opportunities',
    donations: 'donations',
};

export function auditEntityPath(event:any):string|null {
    if(!event || event.entity_deleted) {
        return null;
    }

    const base = entityPaths[event.entity_table];

    if(!base || !event.entity_id || !event.subdomain) {
        return null;
    }

    return `${communityUrl.replace('%subdomain%', event.subdomain)}/${base}/${event.entity_id}`;
}

export function auditActionColor(action:string):string {
    switch(action) {
        case 'created':
            return 'success';
        case 'deleted':
            return 'danger';
        case 'restored':
            return 'warning';
        default:
            return 'primary';
    }
}